import { HttpInterceptorFn } from '@angular/common/http';
import { timeout } from 'rxjs/operators';

/** Default request timeout in milliseconds (30 seconds). */
const DEFAULT_TIMEOUT_MS = 30_000;

/**
 * Timeout interceptor — aborts HTTP requests that exceed the configured duration.
 *
 * Prevents the UI from hanging indefinitely when the server is unresponsive
 * but still reachable (i.e., TCP connection established but no response).
 *
 * The error is thrown as a TimeoutError and propagated to the error handler interceptor.
 */
export const timeoutInterceptor: HttpInterceptorFn = (req, next) => {
  // Skip timeout for file uploads (large payloads need more time)
  const isUpload = req.body instanceof FormData;
  const ms = isUpload ? DEFAULT_TIMEOUT_MS * 4 : DEFAULT_TIMEOUT_MS;

  return next(req).pipe(timeout(ms));
};
